import { Container } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <i className="fas fa-envelope me-2"></i>
            <a href="mailto:eastlondonbrass@hotmail.com" className="text-white text-decoration-none">
              eastlondonbrass@hotmail.com
            </a>
          </div>
          <div className="text-center">
            <p className="mb-0">© 2025 East London Brass Band. Registered charity number: 1091235</p>
          </div>
          <div style={{ width: '200px' }}></div> {/* Spacer to balance layout */}
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
